module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="weather-wrapper"><div data-region="weather-collection"></div> ';
 if(showPaddle) { 
__p+=' <div class="paddles"><button class="left-paddle paddle hidden" data-click="left-paddle-clicked">&larr;</button> <button class="right-paddle paddle" data-click="right-paddle-clicked">&rarr;</button></div> ';
 } 
__p+=' </div>';
}
return __p;
};
